import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormControl} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {Workbook as wb} from "exceljs";
import {ModificacionMarcionesService} from "../../../horas-extras/services/modificacion-marcaciones.service";
import {moduloConciliacionBan} from '../../diccionarios/conciliacionBancariaModulo';
import {
  ParametroConciliacionBancariaService
} from "../../services/conciliacion-bancaria/parametro-conciliacion-bancaria.service";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {RecaudoBancarioService} from "../../services/recaudoBancario/recaudo-bancario.service";
import { AG_GRID_LOCALE_ES } from "../../../../utils/ag-grid-es";
import {Observable, Subscription} from "rxjs";
import {ApiResponse} from "../../../../model/interfaces/response";
import {
  ParametrosGenerales,
  ReporteConciliacion,
  TipoMovimiento,
  ClaveValorModel
} from "../../models/recuadosBancario/ParamExtracionBanca";
import {PARAM_CONFIG} from "../../diccionarios/constRecaudo";
import {CentroLogistico} from "../../../../model/datos-maestros/centroLogistico";
import { Console } from 'console';

@Component({
  selector: 'app-autorizacion-cobros',
  templateUrl: './autorizacion-cobros.component.html',
  styleUrls: ['./autorizacion-cobros.component.css']
})
export class AutorizacionCobrosComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: string = 'ListaCobros';
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;

  //T.23147.sn
  mostrar: boolean;
  formularioModal: FormGroup;   
  columnDefsModal: any;
  textoBuscar: string;
  loading: boolean;
  okDatosRechazo: boolean;
  rowDataModal: any[] = [];
  rowSelectionModal: string;
  frameworkComponentsModal: any;
  rowDataSelected: any[];
  textoMotivo: string;
  textoInfo: string;
  textoOtros: string;
  varFechaHoy: string;
  @ViewChild('close')
  public elementBtnCloseModal: ElementRef<HTMLButtonElement>

  //T.23147.en

  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioExtractos: FormGroup;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any

  gridApiPedidos: any;
  gridColumnApiPedidos: any;
  rowDataPedidos: any[];
  rowSelectionPedidos: any;
  columnDefsPedidos: any[];
  frameworkComponentsPedidos: any;

  gridApiExtractos: any;
  gridColumnApiExtractos: any;
  rowDataExtractos: any[];
  rowSelectionExtractos: any;
  columnDefsExtractos: any[];
  frameworkComponentsExtractos: any;

  rowSelected: any;
  rowSelectedExtractos: any;

  obligatorylocality: boolean = false;
  today: any;
  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];
  listMotivo: any[];
  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  mostrarTabla = false;
  recursosHumanos = false;

  @ViewChild('fileInput') fileInput: ElementRef;

  cmbBanco: any[];
  cmbTipoPago: any[];
  cmbAgencia: any[];
  cmbParametros : ParametrosGenerales[] = [];
  cmbTipoMovimiento: TipoMovimiento[] = [];

  break = false;
  l10nAgGrid = AG_GRID_LOCALE_ES;
  public dataSourceReporte$ :Observable<ApiResponse<ReporteConciliacion[]>> ;
  private subscriptionOp: Subscription;
  public tituloModal: string = '';

  lb_activa_botton: boolean = true;
  lb_activa_bottonprocesar: boolean = true;
  modo_proceso_agrupado: boolean = false;
  rowCobrosSelecte: any[] = [];
  centers: CentroLogistico[] = [];

    public motivosForm = new FormGroup({
      id: new FormControl(null),
      tipo: new FormControl(null, [Validators.required]),
      proveedor: new FormControl('', []),
      fechaIni: new FormControl('', Validators.required),
      fechaFin: new FormControl('', []),
      acidezBase: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
      valorMin: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
      valorMax: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
      //T.23147.sn
      infbanco: new FormControl('', [Validators.maxLength(30)]),
      infRef: new FormControl('', [Validators.maxLength(18)]),
      infFecha: new FormControl('', [Validators.maxLength(30)]),
      infimporte: new FormControl('', [Validators.maxLength(20)]),
      inftipopago: new FormControl('', [Validators.maxLength(20)]),
      infotros: new FormControl('', [Validators.maxLength(75)]),
      motivo1:  new FormControl('', []),
      motivo2:  new FormControl('', []),
      motivo3:  new FormControl('', []),
      motivo4:  new FormControl('', []),
      motivo5:  new FormControl('', []),
      motivo6:  new FormControl('', []),
      motivo7:  new FormControl('', []),
      despro: new FormControl('', []),
      //T.23147.en
    });

  constructor(
    private fb: FormBuilder,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _util: UtilsService,
    private _paramConciBanca: ParametroConciliacionBancariaService,
    private _datosMaestros: DatosMaestrosService,
    private _recaudoservice: RecaudoBancarioService,
  ) {
    this.diccionarioModulo = moduloConciliacionBan;
  }

  ngOnInit(): void {
    //T.23147.sn
    this.mostrar = true; 
    this.motivosForm.controls['infbanco'].disable();
    this.motivosForm.controls['infRef'].disable();
    this.motivosForm.controls['infFecha'].disable();
    this.motivosForm.controls['infimporte'].disable();
    this.motivosForm.controls['inftipopago'].disable();
    this.motivosForm.controls['infotros'];
    //T.23147.en
    this.DAT_BTNS = moduloConciliacionBan.button.buttonsNombre;
    this.DAT_TITULOS = moduloConciliacionBan.titulos.autorizacionCobros;
    this.DAT_BTNCSS = moduloConciliacionBan.button.buttonsCss;
    this.DAT_MSG = moduloConciliacionBan.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.llenarCombos();
    this.getPararemtro();
    this.tituloModal = "Registre los motivos de rechazo del cobro"; 

    this.formulario = this.fb.group({
      fecha_cobro_desde: ['',[Validators.required]],  //date
      fecha_cobro_hasta: ['',[Validators.required]],
      pkBanco: [''],
      ctaBancaria: [''],
      cliente: [''],   //customer
      vendedor: [''],   //seller
      agencia: [''],   //agency
      status: [''], // Si es un enum podrías crear un selector para este campo
      fecha_doc_desde: [''],
      fecha_doc_hasta: [''],
      num_doc: [''],
      montoDesde: [''],
      montoHasta: [''],
      tipoPago: ['']   //paymentType3
    });

    this.formularioExtractos = this.fb.group({
      idEmpresa: '',
      idBanco: '',
      fechaContable_inicio: '',
      fechaContable_fin: '',
      status: '',
      tipo_movimiento: '',
      montoDesde: '',
      montoHasta: '',
      referencia: '',
    });
    this.girdComponent();

    this._datosMaestros.getAllCentroLogistico().subscribe((res) => {
      this.centers = res;
    });
    this.cmbTipoMovimiento = this._recaudoservice.getTiposMovimientos();

  }

  validateForm() {
    return !(this.gridApiExtractos && this.gridApiExtractos.getSelectedRows() && this.gridApiExtractos.getSelectedRows().length > 0);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  

  activarCamposRechazo(event: Event) {
    const checkbox = event.target as HTMLInputElement;
   
    if(checkbox.id == "motivo1"){
        if(checkbox.checked){
          this.motivosForm.controls['infbanco'].enable();
        }else{
          this.motivosForm.controls['infbanco'].setValue("");
          this.motivosForm.controls['infbanco'].disable();
        }
    }
    if(checkbox.id == "motivo2"){
      if(checkbox.checked){
        this.motivosForm.controls['infRef'].enable();
      }else{
        this.motivosForm.controls['infRef'].setValue("");
        this.motivosForm.controls['infRef'].disable();
      }
    }
    if(checkbox.id == "motivo3"){
      if(checkbox.checked){
        this.motivosForm.controls['infFecha'].enable();
      }else{
        this.motivosForm.controls['infFecha'].setValue("");
        this.motivosForm.controls['infFecha'].disable();
      }
    }
    if(checkbox.id == "motivo4"){
      if(checkbox.checked){
        this.motivosForm.controls['infimporte'].enable();
      }else{
        this.motivosForm.controls['infimporte'].setValue("");
        this.motivosForm.controls['infimporte'].disable();
      }
    }
    if(checkbox.id == "motivo5"){
      if(checkbox.checked){
        this.motivosForm.controls['inftipopago'].enable();
      }else{
        this.motivosForm.controls['inftipopago'].setValue("");
        this.motivosForm.controls['inftipopago'].disable();
      }
    }
    if(checkbox.id == "motivo6"){
      if(checkbox.checked){
        this.motivosForm.controls['infotros'].enable();
      }else{
        this.motivosForm.controls['infotros'].setValue("");
      }
    }
    if(checkbox.id == "motivo7"){
      if(checkbox.checked){
        this.motivosForm.controls['infotros'].setValue("");
      }
    }
  }

  llenarCombos() {
    this.cargarBanco();
    this.cargarTipoPago();
    this.cargarAgencia();
  }

  onGridReadyPedidos(params) {
    this.gridApiPedidos = params.api;
    this.gridColumnApiPedidos = params.columnApi;
  }

  onGridReadyExtractos(params) {
    this.gridApiExtractos = params.api;
    this.gridColumnApiExtractos = params.columnApi;
  }


  cargarCobros() {
    console.log(this.formulario.value);

    const params = {
      ...(this.formulario.get('fecha_cobro_desde').value && {fecha_cobro_desde: this.formulario.get('fecha_cobro_desde').value}),
      ...(this.formulario.get('fecha_cobro_hasta').value && {fecha_cobro_hasta: this.formulario.get('fecha_cobro_hasta').value}),
      ...(this.formulario.get('pkBanco').value && {pkBanco: this.formulario.get('pkBanco').value}),
      ...(this.formulario.get('ctaBancaria').value && {ctaBancaria: this.formulario.get('ctaBancaria').value}),
      ...(this.formulario.get('cliente').value && {cliente: this.formulario.get('cliente').value}),
      ...(this.formulario.get('vendedor').value && {vendedor: this.formulario.get('vendedor').value}),
      ...(this.formulario.get('agencia').value && {agencia: this.formulario.get('agencia').value}),
      ...(this.formulario.get('status').value && {status: this.formulario.get('status').value}),
      ...(this.formulario.get('fecha_doc_desde').value && {fecha_doc_desde: this.formulario.get('fecha_doc_desde').value}),
      ...(this.formulario.get('fecha_doc_hasta').value && {fecha_doc_hasta: this.formulario.get('fecha_doc_hasta').value}),
      ...(this.formulario.get('num_doc').value && {num_doc: this.formulario.get('num_doc').value}),
      ...(this.formulario.get('montoDesde').value && {montoDesde: this.formulario.get('montoDesde').value}),
      ...(this.formulario.get('montoHasta').value && {montoHasta: this.formulario.get('montoHasta').value}),
      ...(this.formulario.get('tipoPago').value && {tipoPago: this.formulario.get('tipoPago').value}),
    };

    this.loading = true;
    this.mostrarTabla = true;
    this.varFechaHoy = (new Date).toString(); //this.formulario.get('fecha_cobro_hasta').value;  //mams
    console.log("fecha string "+ this.varFechaHoy );
    this._recaudoservice.getCobrosPendientes(params).subscribe( (res: any) => {
        console.log(res);
      if (res.respuesta && res.respuesta.registros && res.respuesta.registros.length > 0) {
        console.log("paso1")
        this.rowData = res.respuesta.registros.flatMap(obj =>
          obj.pagosDetalle.map(pagoDetalle =>
            ({pagoDetalle, cobro: obj})
          )
        );
      } else {
        this.rowData = [];
        console.log("pasoNotdata")
      }
      this.loading = false;
    },
    (error) => {
      this.loading = false;
      this.rowData = [];
      console.log(error);
      console.log("erro")
    }
    );
  }


  girdComponent() {
    const $this = this;
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        sortable: true,
        filter: true,
        width: 80,
        checkboxSelection: true,
        onRowSelected: (params) => {
          console.log('Checkbox seleccionado:', params.data);
          // Aquí puedes llamar a tu función o evento
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        enable: this.lb_activa_bottonprocesar,
        cellRendererParams: {
          onClick: this.procesarExtractos.bind(this),
          label: this.DAT_BTNS.procesar,
          colorBoton: this.DAT_BTNCSS.info,
          textoAyuda: 'Procesar individual'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        cellRendererParams: {
          //onClick: this.rechazarCobro.bind(this),
          //onClick: this.callModal(this),
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.rechazar,
          colorBoton: this.DAT_BTNCSS.danger,
          textoAyuda: 'Rechazar'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        cellRendererParams: {
          onClick: this.ejecutarRechazoDirecto.bind(this),
          label: 'X',
          colorBoton: this.DAT_BTNCSS.warning,
          textoAyuda: 'Ejecutar Rechazo Directo'
        }
      },
      {
        headerName: 'COBRO ID',
        field: 'cobro.cobroId',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'CONSECUTIVO',
        field: 'pagoDetalle.pagConsecutivo',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: 'BANCO ID',
        field: 'pagoDetalle.pagIdBancoContable',
        sortable: true,
        filter: true,
        width: 110
      },
      {
        headerName: 'BANCO',
        field: 'pagoDetalle.nameBancoContable',
        sortable: true,
        filter: true,
        width: 150/*,
        cellRenderer: params => {
          return $this.getDescripcionbanco(params.value);//$this.getBadgeStatus(params.data.status);
        }*/
      },
      {
        headerName: 'FORMA DE PAGO',
        field: 'pagoDetalle.tipoPago.descripcion',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'REFERENCIA',
        field: 'pagoDetalle.pagNumDocumento',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: 'MONTO',
        field: 'pagoDetalle.pagValor',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'CUENTA',
        field: 'pagoDetalle.pagCtaBancaria',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'CLIENTE',
        field: 'cobro.cliente.nombreCliente1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'RUC CLIENTE',
        field: 'cobro.cliente.rucCliente',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'VENDEDOR',
        field: 'cobro.vendedor.nombreVendedor1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'CODIGO VENDEDOR',
        field: 'cobro.vendedor.loginVendedor',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '# PEDIDOS',
        field: 'cobro.pedidos.length',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ESTADO',
        field: 'pagoDetalle.status',
        sortable: true,
        filter: true,
        width: 200,
        cellRenderer: params => {
          return $this.getBadgeStatus(params.value);//$this.getBadgeStatus(params.data.status);
        }
      }
    ];
    this.rowSelection = 'multiple'; //'single';
    this.gridOptions = {
      // ...
      onSelectionChanged: (params) => {
        console.log('Selección cambiada:', params.api.getSelectedRows());
        // Aquí puedes llamar a tu función o evento
        if (params.api.getSelectedRows().length >= 2) {
           this.lb_activa_botton = false
           this.lb_activa_bottonprocesar = false
          console.log(params.api.getSelectedRows().length, '-' , this.lb_activa_botton)
        } else {
          this.lb_activa_botton = true
          this.lb_activa_bottonprocesar = true
          console.log(params.api.getSelectedRows().length, '-*', this.lb_activa_botton)
        }
      }
    };
  }


  girdComponentPedidos() {
    this.frameworkComponentsPedidos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsPedidos = [
      {
        headerName: 'CLIENTE',
        field: 'rowData.cobro.cliente.nombreCliente1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'VENDEDOR',
        field: 'rowData.cobro.vendedor.nombreVendedor1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'FORMA DE PAGO',
        field: 'rowData.pagoDetalle.tipoPago.descripcion',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'AGENCIA',
        field: 'rowData.cobro.agencia.descripcion',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'FECHA PEDIDO',
        field: 'pedFechaCreacion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'MONTO',
        field: 'pedValorPedido',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelectionPedidos = 'single';
  }


  girdComponentExtractos() {
    const $this = this;
    this.frameworkComponentsExtractos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsExtractos = [
      {
        headerName: '',
        sortable: true,
        filter: true,
        width: 80,
        checkboxSelection: true,
      },
      {
        headerName: 'BANCO ID',
        field: 'idBanco',
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'CUENTA',
        field: 'cuentaBancaria',
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'FECHA EXTRACTO',
        field: 'fechaExtracto',
        sortable: true,
        filter: true,
        width: 170,
        valueGetter: function (data) {
          return $this._util.getFechaInputFormat(data.data.fechaExtracto)
        }
      },
      {
        headerName: 'NUMERO EXTRACTO',
        field: 'numeroExtracto',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NUMERO REFERENCIA',
        field: 'numeroReferencia',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'FECHA DOCUMENTO',
        field: 'fechaContable',
        sortable: true,
        filter: true,
        width: 170,
        valueGetter: function (data) {
          return $this._util.getFechaInputFormat(data.data.fechaContable)
        }
      },
      {
        headerName: 'MONTO',
        field: 'monto',
        sortable: true,
        filter: true,
        width: 170
      },

      {
        headerName: 'TIPO MOV.',
        field: 'tipoMovExtracto',
        sortable: true,
        filter: true,
        width: 140,
        valueGetter: function (data) {
          return $this.findTiposMovimientoDes(data.data.tipoMovExtracto)
        }
      },

      {
        headerName: 'ESTADO',
        field: 'status',
        sortable: true,
        filter: true,
        width: 200,
        cellRenderer: params => {
          return $this.getBadgeStatus(params.value);//$this.getBadgeStatus(params.data.status);
        }
      }
    ];
    this.rowSelectionExtractos = 'single';
  }

  //T.23147
  validarDatosRechazo() {
    this.textoMotivo = "";
    this.textoInfo = "";
    this.textoOtros = "";

    let data = this.motivosForm.getRawValue();
    this.okDatosRechazo = true;
    
    if(data.motivo1){
      if(data.infbanco != undefined && data.infbanco != null){
        if(data.infbanco.length == 0){
          this.okDatosRechazo = false;
        }else{
          this.textoMotivo = this.textoMotivo + "Error banco;";
          this.textoInfo = this.textoInfo + data.infbanco + "; ";
        }
      }
    }
    if(data.motivo2){
      if(data.infRef != undefined && data.infRef != null){
        if(data.infRef.length == 0){
          this.okDatosRechazo = false;
        }else{
          this.textoMotivo = this.textoMotivo + "Error referencia;";
          this.textoInfo = this.textoInfo + data.infRef + "; ";
        }
      }
    }
    if(data.motivo3){
      if(data.infFecha != undefined && data.infFecha != null){
        if(data.infFecha.length == 0){
          this.okDatosRechazo = false;
        }else{
          this.textoMotivo = this.textoMotivo + "Error fecha;";
          this.textoInfo = this.textoInfo + data.infFecha + "; ";
        }
      }
    }
    if(data.motivo4){
      if(data.infimporte != undefined && data.infimporte != null){
        if(data.infimporte.length == 0){
          this.okDatosRechazo = false;
        }else{
          this.textoMotivo = this.textoMotivo + "Error importe;";
          this.textoInfo = this.textoInfo + data.infimporte + "; ";
        }
      }
    }
    if(data.motivo5){
      if(data.inftipopago != undefined && data.inftipopago != null){
        if(data.inftipopago.length == 0){
          this.okDatosRechazo = false;
        }else{
          this.textoMotivo = this.textoMotivo + "Error tipo de pago;";
          this.textoInfo = this.textoInfo + data.inftipopago + "; ";
        }
      }
    }
    if(data.motivo6 != undefined && data.motivo6 != null){
      if(data.motivo6){
        if(data.infotros.length == 0){
          this.okDatosRechazo = false;
        }else{
          this.textoMotivo = this.textoMotivo + "Duplicado;";
        }
      }
    }
    if(data.motivo7 != undefined && data.motivo7 != null){
      if(data.motivo7){
        this.textoMotivo = this.textoMotivo + "Sin registros coincidentes;";
      }
    }
    if(this.textoMotivo.length <= 5){
      this.okDatosRechazo = false;
    }

    if(data.infotros != null){
      if(data.infotros.length > 0){
        this.textoOtros = this.textoOtros + data.infotros;
      }
    }
    if(this.okDatosRechazo){
      this.elementBtnCloseModal.nativeElement.click();
      //Limpiamos ventana modal
      this.motivosForm.reset();
      this.motivosForm.controls['infbanco'].disable();
      this.motivosForm.controls['infRef'].disable();
      this.motivosForm.controls['infFecha'].disable();
      this.motivosForm.controls['infimporte'].disable();
      this.motivosForm.controls['inftipopago'].disable();
      this.motivosForm.controls['infotros'];
      this.rechazarCobro();
    }else{ 
      this._util.mensajeErrorVisto("Ingrese la información de rechazo requerida.");
    }
  }

  rechazarCobro() {
    console.log(this.rowDataSelected);
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.rechazar,
        text: ``,
        action: this.DAT_BTNS.rechazar,
        funcion: this._paramConciBanca.rechazarCobro(this.rowDataSelected, this.textoMotivo, this.textoInfo, this.textoOtros),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  ejecutarRechazoDirecto({rowData}) {
    console.log(rowData);
    this.loading = true;
    const idCobro = rowData.cobro.cobroId;
    const secuencia = rowData.pagoDetalle.pagConsecutivo;
    
    this._util.confirmarSincronoPromesa(
      {
        title: 'Ejecutar Rechazo Directo',
        text: `¿Está seguro de ejecutar el rechazo directo?`,
        action: 'Ejecutar',
        funcion: this._paramConciBanca.ejecutarRechazoDirecto(idCobro, secuencia),
      }
    ).then((res: any) => {
      this.cargarCobros();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  procesarExtractos({rowData}, isIndividual = true) {
    this.titulo = this.DAT_TITULOS.tituloCardProcesarExtractos;
    this.mostrarGridLista = 'ListaExtractos';
    this.textBoton = this.DAT_BTNS.procesar;
    console.log(rowData);
    console.log("varFechaHoy "+ this.varFechaHoy);
    console.log("FECHA COBRO HASTA"+this.formulario.get('fecha_cobro_hasta').value);
    
    //console.log(this.cmbParametros);
    if (this.cmbParametros[0] && this.cmbParametros[0].valorParametroNum) {
      console.log("Dias Tolerancia:"+this.cmbParametros[0].valorParametroNum);
      this.formularioExtractos.get('fechaContable_inicio').setValue(
        this._util.getFechaAdddays(this.formulario.get('fecha_cobro_desde').value,this.cmbParametros[0].valorParametroNum*-1)
      );
      //this.formulario.get('fecha_cobro_hasta').setValue(new Date());
      
      this.formulario.get('fecha_cobro_hasta').setValue(
        this._util.getFechaAdddays(this.varFechaHoy,this.cmbParametros[0].valorParametroNum)
      );
      this.formularioExtractos.get('fechaContable_fin').setValue(
         this._util.getFechaAdddays(this.formulario.get('fecha_cobro_hasta').value,this.cmbParametros[0].valorParametroNum)
      );
      
    } else {
      this.formularioExtractos.get('fechaContable_inicio').setValue(this.formulario.get('fecha_cobro_desde').value);
    }
    let sumImportes = 0;

    if (isIndividual){
      sumImportes = rowData && rowData.pagoDetalle && rowData.pagoDetalle.pagValor ? rowData.pagoDetalle.pagValor : '';
    } else {
      this.gridApi.getSelectedRows().forEach((row) => {
        console.log(row);
        //sumImportes = row.pagoDetalle.pagValor + sumImportes;
        //redondeo a 2 decimales
        sumImportes = parseFloat((row.pagoDetalle.pagValor + sumImportes).toFixed(2));
      });
    }

    console.log("Sum-importes **",sumImportes);
    this.formularioExtractos.get('fechaContable_fin').setValue(this.formulario.get('fecha_cobro_hasta').value);
    this.formularioExtractos.get('idBanco').setValue(rowData && rowData.pagoDetalle && rowData.pagoDetalle.pagIdBancoContable ? rowData.pagoDetalle.pagIdBancoContable : '');
    this.formularioExtractos.get('idEmpresa').setValue( rowData && rowData.pagoDetalle && rowData.pagoDetalle.pagEmpresa ? rowData.pagoDetalle.pagEmpresa : '1001' );
    this.formularioExtractos.get('status').setValue('NORMAL');
    this.formularioExtractos.get('tipo_movimiento').setValue(this.findTiposMovimiento(rowData && rowData.pagoDetalle && rowData.pagoDetalle.tipoPago.descripcion ? rowData.pagoDetalle.tipoPago.descripcion : ''));
    this.formularioExtractos.get('montoDesde').setValue(sumImportes);
    this.formularioExtractos.get('montoHasta').setValue(sumImportes);
    this.formularioExtractos.get('referencia').setValue(rowData && rowData.pagoDetalle && rowData.pagoDetalle.pagNumDocumento ? rowData.pagoDetalle.pagNumDocumento : '');
    //this.getExtractos(rowData);
    this.getExtractosv2(rowData);
    //this.rowDataPedidos = rowData.pedidos;
    this.girdComponentExtractos();
  }

  cargarBanco() {
    // this._paramConciBanca.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
    this._datosMaestros.getAllBancoActivos().subscribe((resp) => {
      this.cmbBanco = this.concatenarBancoId(resp);
    }, (error) => {
      this.cmbBanco = [];
      console.log(error);
    });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      e['name'] = e.dscaBanco;
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }


  cargarTipoPago() {
    this._datosMaestros.getAllTipoPago().subscribe((resp) => {
      this.cmbTipoPago = resp;
    }, (error) => {
      this.cmbTipoPago = [];
      console.log(error);
    });
  }

  cargarAgencia() {
    this._datosMaestros.getAllOficinasVentas().subscribe((resp) => {
      this.cmbAgencia = resp;
    }, (error) => {
      this.cmbAgencia = [];
      console.log(error);
    });
  }

  procesarExtractosClick() {
    this.loading = true;
    //this.rowSelectedExtractos = rowData;

    this.rowSelectedExtractos = this.gridApiExtractos.getSelectedRows();

    let conciliacionDatos = this.rowSelectedExtractos.map(data =>
      ({
        idEmpresa: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagEmpresa ? this.rowSelected.pagoDetalle.pagEmpresa : '',
        idBanco: this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
        claveBanco: data && data.claveBanco ? data.claveBanco : '',
        //cuentaBancaria: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagCtaBancaria ? this.rowSelected.pagoDetalle.pagCtaBancaria : '',
        cuentaBancaria: data && data.cuentaBancaria ? data.cuentaBancaria : '',
        numeroExtracto: data && data.numeroExtracto ? data.numeroExtracto : '',
        numeroReferencia: data && data.numeroReferencia ? data.numeroReferencia : '',
        idConciBancaDeta: data && data.idConciBancaDeta ? data.idConciBancaDeta : '',
      })
    );
    let payload = {
      cobroId: this.rowSelected && this.rowSelected.cobro && this.rowSelected.cobro.cobroId ? this.rowSelected.cobro.cobroId : '',
      pagConsecutivo: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagConsecutivo ? this.rowSelected.pagoDetalle.pagConsecutivo : 1,
      conciliacionDatos: conciliacionDatos
    };
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: ``,
        action: this.DAT_BTNS.procesar,
        funcion: this._paramConciBanca.procesarCobro(payload),
      }
    ).then((res: any) => {
        this.loading = false;
        this.cargarCobros();
        this.regresar();
      }, () => {
        this.loading = false;
      }
    );
  }

  getExtractos(data) {
    let payload = {
      'fechaExtracto': this.formulario && this.formulario.get('fecha_cobro_desde') && this.formulario.get('fecha_cobro_desde').value ? this.formulario.get('fecha_cobro_desde').value : '',
      'idBanco': this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
      'idEmpresa': data && data.pagoDetalle && data.pagoDetalle.pagEmpresa ? data.pagoDetalle.pagEmpresa : '',
    };
    this.rowSelected = data;
    this.loading = true;
    this._paramConciBanca.getAllExtractoBancario(payload).subscribe((res: any) => {
      console.log("Rest->",res);
      this.rowDataExtractos = res.map(data => (
        {
          ...data,
        }
      ));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowDataExtractos = [];
    });
  }

  getExtractosv2(data?) {
    console.log(this.formularioExtractos.value);

   /* const params = {
      ...(this.formularioExtractos.get('idEmpresa').value && { idEmpresa: this.formularioExtractos.get('idEmpresa').value }),
      ...(this.formularioExtractos.get('idBanco').value && { idBanco: this.formularioExtractos.get('idBanco').value }),
      ...(this.formularioExtractos.get('fechaExtracto_inicio').value && { fechaExtracto: this.formularioExtractos.get('fechaExtracto_inicio').value }),
      ...(this.formularioExtractos.get('fechaExtracto_fin').value && { fechaExtracto: this.formularioExtractos.get('fechaExtracto_fin').value }),
    }*/

    if (data && data.pagoDetalle) {
      this.rowSelected = data;
    }
    this.loading = true;
    //console.log(params);
    this.dataSourceReporte$ = this._recaudoservice.getreporteConciliacion(this.formularioExtractos.value);

    this.dataSourceReporte$.subscribe((resp: ApiResponse<ReporteConciliacion[]>) => {
      console.log("Restv2->",resp);
      this.rowDataExtractos = resp.respuesta;
      this.loading = false;
    }, (error) => {
      this.loading = false;
      this.rowDataExtractos = [];
      console.log(error);
    });

  }

  verPedidos({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardPedidos;
    this.mostrarGridLista = 'ListaPedidos';
    this.rowSelected = rowData;
    this.rowDataPedidos = rowData.cobro.pedidos.map(data => (
      {
        ...data,
        rowData: this.rowSelected
      }
    ));
    this.girdComponentPedidos();
  }


  regresar() {
    this.formularioExtractos.reset();
    this.mostrarGridLista = 'ListaCobros';
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }


  acciones(event) {
    if (event === 'guardar') {
      if (this.modo_proceso_agrupado) {
        this.procesarExtractosCobroAgrupado();
      } else {
        this.procesarExtractosClick();
      }

    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = 'ListaCobros';
    }
    this.modo_proceso_agrupado = false;
  }

  resetForm() {
    this.formulario.reset();
    this.rowData  = [];
  }

  getBadgeStatus(data: any): any {
    if (data === 'NORMAL') {
      return `<span class="badge text-bg-primary">${data}</span>`;
    } else if (data === 'BLOQUEADO_POR_CONFIRMAR') {
      return `<span class="badge text-bg-warning">${data}</span>`;
    } else if (data === 'DESBLOQUEADO') {
      return `<span class="badge text-bg-success">${data}</span>`;
    } else {
      return `<span class="badge text-bg-secondary">${data}</span>`; // o cualquier otro valor por defecto
    }
  }

  getDescripcionbanco(data: any){
     const descrip = this.cmbBanco.filter(x => x.idBanco === data);
     return descrip[0].name;
  }

  getPararemtro() {
    this.subscriptionOp = this._recaudoservice.cargaParametrosGenerales(PARAM_CONFIG.NODE_RECAUDO_DIAS_TOLERANCIA).subscribe((resp: ApiResponse<ParametrosGenerales[]>) => {
      this.cmbParametros = resp.respuesta;
      console.log(this.cmbParametros);
    }, (error) => {
      this.cmbParametros = [];
      console.log(error);
    });
  }

  agruparExtractos(){
    console.log("Agrupateee ",this.gridApi.getSelectedRows().length);
/*  let sumImportes = 0;
    this.gridApi.getSelectedRows().forEach((row) => {
      console.log(row);
      sumImportes = row.pagoDetalle.pagValor + sumImportes;
    });
    console.log("Sum-importes **",sumImportes);*/
    this.rowCobrosSelecte = this.gridApi.getSelectedRows();

   console.log("el row q guarde->",this.rowCobrosSelecte);

    const selectedRows = this.gridApi.getSelectedRows();
    const idCliente = selectedRows[0].cobro.cliente.idCliente;
    const mismaIdCliente = selectedRows.every(row => row.cobro.cliente.idCliente === idCliente);
    if (!mismaIdCliente) {
      this._util.mensajeErrorVisto("Los registros seleccionados no pertenecen al mismo Cliente, por favor revisar.",true);
      return;
    }

    const idBancos = selectedRows[0].pagoDetalle.pagIdBancoContable;
    const mismaIdBanco = selectedRows.every(row => row.pagoDetalle.pagIdBancoContable === idBancos);

    if (!mismaIdBanco) {
      this._util.mensajeErrorVisto("Los registros seleccionados no pertenecen al mismo Banco, por favor revisar.",true,4000);
      return;
    }

    const tipoPago = selectedRows[0].pagoDetalle.tipoPago.descripcion;
    const mismaTipoPago = selectedRows.every(row => row.pagoDetalle.tipoPago.descripcion === tipoPago);

    if (!mismaTipoPago) {
      this._util.mensajeErrorVisto("Los registros seleccionados no pertenecen al misma Forma de Pago, por favor revisar.",true,4000);
      return;
    }
    const numReferencia = selectedRows[0].pagoDetalle.pagNumDocumento;
    const mismaNumReferencia = selectedRows.every(row => row.pagoDetalle.pagNumDocumento === numReferencia);
    console.log("numReferencia->",numReferencia);
    console.log("mismaNumReferencia->",mismaNumReferencia);

    if (!mismaNumReferencia) {
      this._util.mensajeErrorVisto("Los registros seleccionados no tienen el mismo Numero de Referencia, por favor revisar.",true,4000);
      return;
    }

    this.modo_proceso_agrupado = true;

    const selectedRow = this.gridApi.getSelectedRows()[0];
    if (selectedRow) {
      ///se reliza mejor en la funcionm procesarExtractos
     /// selectedRow.pagoDetalle.pagValor = sumImportes;
      this.procesarExtractos({ rowData: selectedRow }, false);
    }
  }

  procesarExtractosCobroAgrupado() {
    this.loading = true;
    this.rowSelectedExtractos = this.gridApiExtractos.getSelectedRows();

    let conciliacionDatos = this.rowSelectedExtractos.map(data =>
      ({
        idEmpresa: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagEmpresa ? this.rowSelected.pagoDetalle.pagEmpresa : '',
        idBanco: this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
        claveBanco: data && data.claveBanco ? data.claveBanco : '',
        //cuentaBancaria: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagCtaBancaria ? this.rowSelected.pagoDetalle.pagCtaBancaria : '',
        cuentaBancaria: data && data.cuentaBancaria ? data.cuentaBancaria : '',
        numeroExtracto: data && data.numeroExtracto ? data.numeroExtracto : '',
        numeroReferencia: data && data.numeroReferencia ? data.numeroReferencia : '',
        idConciBancaDeta: data && data.idConciBancaDeta ? data.idConciBancaDeta : '',
      })
    );

/*    let payload = {
      cobroId: this.rowSelected && this.rowSelected.cobro && this.rowSelected.cobro.cobroId ? this.rowSelected.cobro.cobroId : '',
      pagConsecutivo: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagConsecutivo ? this.rowSelected.pagoDetalle.pagConsecutivo : 1,
      conciliacionDatos: conciliacionDatos
    };*/

    let payloads: { cobroId: string, pagConsecutivo: number, conciliacionDatos: any }[] = [];
    console.log("el row q ante de ajustra->",this.rowCobrosSelecte);
    this.rowCobrosSelecte.forEach((row) => {

      console.log(row);

      let payload = {
        cobroId: row && row.cobro && row.cobro.cobroId ? row.cobro.cobroId : '',
        pagConsecutivo: row && row.pagoDetalle && row.pagoDetalle.pagConsecutivo ? row.pagoDetalle.pagConsecutivo : 1,
        conciliacionDatos: conciliacionDatos
      };

      payloads.push(payload)

    });

    console.log('final->',payloads);



    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: ``,
        action: this.DAT_BTNS.procesar,
        funcion: this._paramConciBanca.procesarCobroMasive(payloads),
      }
    ).then((res: any) => {
        this.loading = false;
        console.log("rs->",res);
        if(res && res.respuesta && res.respuesta.length > 0) {
          res.respuesta.forEach(x => {
            this._util.mensajeOKToast(x,3000);
          })
        }
        this.cargarCobros();
        this.regresar();
      }, () => {
        this.loading = false;
      }
    );
  }

  findTiposMovimiento(data: any) :any{
    if(data === null || data === undefined) return '';
    console.log("dats-> ",data)
    console.log("dats-> ",this.cmbTipoMovimiento)
    const id = this.cmbTipoMovimiento.find( x => x.descripcion == data.trim());
    return id ? id.codigo : '';
  }

  findTiposMovimientoDes(data: any) :any{
    if(data === null || data === undefined) return '';
    const label = this.cmbTipoMovimiento.find( x => x.codigo == data);
    return label ? label.descripcion : '';
  }

  callModal(target) {
    document.getElementById('abrirModal').click();
  }

  
  mostrarFormularios() {
    this.mostrar = false;
    this.formulario.setValue({
      codigo1: '',
      codigo2: '',
      ruc1: '',
      ruc2: '',
      nombre: ''
    });
    this.rowData = [];
  }

  editar({rowData}) {
    this.rowDataSelected = rowData;
    /*
    this.agregarForm.patchValue(rowData);
    this.agregarForm.get('fechaIni').disable();
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;

    if(rowData.tipo == "Acidez") this.agregarForm.get("tipo").setValue(0)
    if(rowData.tipo == "Humedad_Impureza") this.agregarForm.get("tipo").setValue(1)

    this.agregarForm.get('id').disable({onlySelf: true});
    this.agregarForm.get('tipo').disable({onlySelf: true});
    this.agregarForm.get('valorMin').disable({onlySelf: true});
    this.agregarForm.get('valorMax').disable({onlySelf: true});
    this.agregarForm.get('proveedor').disable({onlySelf: true});
    this.agregarForm.get('incremento').disable({onlySelf: true});
*/
    this.openModal();
  }
/*
  onCheckOpcion() {
    
  }
*/
  

  openModal() {
    document.getElementById('abrirModal').click();
  }

  /*obtenerMotivos(motivo){
  //  this.selectedMotivos = motivo; xq seleccionaba por defaulcr
   // this.selectedMotivos = this.getValueArray(this.selectedMotivos);
    console.log("Llama a la funcion obtenerMotivos");
    console.log(this.selectedMotivos);
  }*/


}
